import stage from '../components/stage'
import renderer from '../components/render'
import Component from 'gia/Component'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import Flickity from 'flickity'
import 'flickity-fade'


class Slider extends Component {

    constructor(element) {


        super(element);
        this.element = element
        this.el = $(element)

        this.ref = {
            slides: null
        }

      

    }

    mount() {
        
        this.flkty = new Flickity(this.ref.slides, {
            wrapAround: true,
            autoPlay: 4000,
            //fade: true,
            prevNextButtons: false,
            pageDots: true,
            pauseAutoPlayOnHover: false
        });


    }



    unmount() {
       
    }


}

module.exports = Slider
